import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { TriggerType } from 'dashboard/models/trigger';
import { WorkflowVersion, WorkflowVersionAttributes } from 'dashboard/models/workflow-version';
import {
  setWorkflowVersions,
  WorkflowVersionsFilterParams,
} from 'dashboard/redux/actions/workflow-versions';
import { ApiEndpoint, ApiModel, PaginationParams } from 'lib/interfaces/api';

export function loadWorkflowVersionList({
  workflowId,
  triggerType,
  currentPage,
  pageSize,
}: {
  workflowId: string | null;
  triggerType?: TriggerType;
  currentPage?: number;
  pageSize?: number;
}) {
  return async (dispatch: Dispatch) => {
    const params = createParamsForList({
      workflowIds: workflowId ? [workflowId] : [],
      'trigger-type': triggerType,
    });

    const paramsFull = {
      ...params,
      page: {
        number: currentPage,
        size: pageSize,
      },
    };

    const workflowVersionsResponse = await SessionClientDashboard.listResource<
      WorkflowVersion,
      PaginationParams
    >(ApiEndpoint.WorkflowVersion, paramsFull);

    const workflowVersions = workflowVersionsResponse.data;
    const paginationParams = workflowVersionsResponse.meta;

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(setWorkflowVersions(workflowVersions, paginationParams));
  };
}

export function updateWorkflowVersion(
  workflowVersion: WorkflowVersion,
  attributes: Partial<WorkflowVersionAttributes>,
) {
  return async () => {
    const response = await SessionClientDashboard.updateResource<WorkflowVersion>({
      type: ApiModel.WorkflowVersion,
      id: workflowVersion.id,
      attributes,
    });

    return response.data;
  };
}

function createParamsForList(workflowVersionFilters: WorkflowVersionsFilterParams) {
  const { workflowIds, 'trigger-type': triggerType } = workflowVersionFilters;

  const params = {
    filter: {
      workflowIds,
      'trigger-type': triggerType,
    },
    sort: '-',
  };

  return params;
}
